import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import {
  ReportCard,
  ReportCardColorBar,
  ReportCardContainer,
  ReportCardCounter,
  ReportCardImageContainer,
  ReportCardImage,
  ReportCardName,
  ReportCardIcons,
  IconContainer,
  Image,
} from "./styled.components";
import { randomColor } from "utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import "../../assets/css/reportcard/index.css";

type ReportCardsProps = {
  dataCards: any;
  isSelected: boolean;
  handleOnClick: (e: any) => void;
  handleFavoriteOnClick: (e: any) => void;
  handleLinkOnClick: (e: any) => void;
};

const ReportCards: FunctionComponent<ReportCardsProps> = ({
  dataCards,
  isSelected,
  handleOnClick,
  handleFavoriteOnClick,
  handleLinkOnClick,
}) => {
  const { defaultBrand, defaultReport } = useSelector(
    (state: any) => state.theme
  );
  const { catalogs } = useSelector((state: any) => state.theme);
  const { context } = useSelector((state: any) => state.theme);
  const { reporteColor } = useSelector((state: any) => state.theme);

  const handleRenderCardViews = (item: any, index: number) => {
    return (
      <ReportCard
        key={`report-card-${item.idVista}`}
        bg={context?.backgroundItem}
        textColor={context?.textColor}
      >
        <ReportCardContainer>
          {!isSelected ? (
            <ReportCardCounter>{item.hijos.length}</ReportCardCounter>
          ) : (
            <ReportCardIcons>
              <IconContainer>
                {item.reciente ? (
                  <WatchLaterIcon
                    className={"report-icons"}
                    style={{ color: catalogs?.context }}
                  />
                ) : (
                  <></>
                )}
                <FavoriteIcon
                  className={"report-icons"}
                  style={{
                    color: item.favorito ? catalogs?.context : catalogs?.item,
                  }}
                  onClick={() => handleFavoriteOnClick(item)}
                />
              </IconContainer>
              <IconContainer>
                <Image
                  src={"/commons/link-plus.svg"}
                  onClick={() => handleLinkOnClick(item)}
                />
              </IconContainer>
            </ReportCardIcons>
          )}
          <ReportCardImageContainer
            onClick={() => handleOnClick({ ...item, isSelected: isSelected })}
          >
            <ReportCardImage
              src={
                item.signPath != ""
                  ? item.signPath
                  : !isSelected
                  ? `${process.env.PUBLIC_URL}${defaultBrand}`
                  : `${process.env.PUBLIC_URL}${defaultReport}`
              }
            />
          </ReportCardImageContainer>
          <ReportCardName
            onClick={() => handleOnClick({ ...item, isSelected: isSelected })}
          >
            {item.descripcionMenu}
          </ReportCardName>
        </ReportCardContainer>
        <ReportCardColorBar bgColor={reporteColor || randomColor()} />
      </ReportCard>
    );
  };

  return (
    <>
      {dataCards
        .filter((report: any) => report.idVista > 0)
        .map(handleRenderCardViews)}
    </>
  );
};

export default ReportCards;
